import React, { useState, useEffect } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TextField,
  Typography,
  Checkbox,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputMask from "react-input-mask";
import { useTheme } from "@material-ui/core/styles";
import Transition from "../../stateless/Transition";
import styles from "../../../styles/global-styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ConfirmButtons } from "../../stateless/ConfirmButtons";
import UsoCfdiSelect from "../../shared/selects/UsoCfdiSelect";
import { buildJsonReceipt } from "../../../_utils/receipt";
import { actions as actionsAlert } from "../../../redux/actions/alert";
import { FacturaDigitalService } from "../../../services/facturaDigital.service";
import { ProductService } from "../../../services/product.service";
import { SiteService } from "../../../services/site.service";
import { validateReceiptForm } from "../../../_utils/utils";
import { connect } from "react-redux";
import { CBB_SEND_EMAIL } from "../../../_constants/receiptInfo";

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: "1.5vh",
  },
  box: {
    marginTop: "20px",
  },
  formControl: styles.globalFormControl,
  subtitle: styles.subtitle,
  textField4: {
    "& .MuiOutlinedInput-root": {
      width: "14vw !Important",
      maxWidth: 280,
      minWidth: 180,
      border: "0.4px solid #f2f2f2",
    },
  },
}));

const GenerateReceipt = ({
  onClose,
  open,
  productsForReceipt,
  siteInfo,
  addAlert,
  detailAlert,
  receiptCreated,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [receiptObject, setReceiptObject] = useState({});
  const [checkboxState, setCheckboxState] = useState(false);
  const [acceptButtonDisabled, setAcceptButtonDisabled] = useState(false);
  const [errorCFDI, setErrorCFDI] = React.useState(false);

  useEffect(() => {
    if (checkboxState) {
      setReceiptObject({
        ...receiptObject,
        rfc: "XAXX010101000",
        name: "Publico en general",
        usoCfdi: "G03",
      });
    } else {
      setReceiptObject({});
    }
  }, [checkboxState]);

  const handleClose = () => onClose();

  const handleSubmitReceipt = async () => {
    const receipt = buildJsonReceipt(
      productsForReceipt,
      receiptObject,
      checkboxState,
      siteInfo
    );
    const receiptError = { info: "Error al generar factura  " };
    const updateProductError = {
      info: "Error al actualizar el campo de 'factura-generada' de los productos",
    };

    console.log("receipt ====== ", receipt);
    const { isError, message } = validateReceiptForm(receiptObject);
    if (isError) {
      console.log("isError ====== ", isError);
      console.log("message ====== ", message);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message,
        time: 3000,
      });
      return;
    } else {
      setAcceptButtonDisabled(true);
      try {
        const { data, status } = await FacturaDigitalService.createCFDI(
          JSON.stringify(receipt)
        );
        console.log("data receipt", data);
        console.log("status receipt", status);

        if (status === 200) {
          /** update folio in site (value use it facturacion)*/
          await SiteService.updateSiteById(siteInfo.id, {
            folio: siteInfo.folio,
          });

          /** update products where invoice was emitted */
          const productUpdated =
            await ProductService.updateBulkProductFactureCreated(
              productsForReceipt.map((item) => item.productId)
            );
          if (productUpdated.status === 201) {
            if (data.cfdi?.UUID) {
              try {
                console.log("servicio FACTURADIGITAL sendEmail");
                // const emailSend = await FacturaDigitalService.sendEmail(
                //   data.cfdi.UUID,
                //   checkboxState ? receiptObject.email : null,
                //   "Te mandamos el XML y .PDF de tu factura generada",
                //   CBB_SEND_EMAIL
                // );
                // console.log("emailSend", emailSend);
              } catch (error) {
                console.log("error send email", error);
                receiptCreated(false, error);
              }
            }
            receiptCreated(true);
          } else throw updateProductError;
        } else throw receiptError;
      } catch (error) {
        console.log("error receipt", error);
        receiptCreated(false, error);
      }
    }
  };

  const handleInputText = ({ target: { name, value } }) => {
    setReceiptObject({ ...receiptObject, [name]: value });
  };

  const handleCFDISelected = (value) => {
    setReceiptObject({ ...receiptObject, usoCfdi: value });
  };

  const handleGlobalReceipt = () => {
    setCheckboxState(!checkboxState);
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      onClose={handleClose}
      fullScreen={fullScreen}
      keepMounted
      TransitionComponent={Transition}
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Generar factura
      </DialogTitle>
      <DialogContent>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} sm={6}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                RFC
              </Typography>
              <TextField
                name="rfc"
                disabled={checkboxState}
                value={receiptObject.rfc || ""}
                inputProps={{ maxLength: 13 }}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className={classes.box}>
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Razón social
              </Typography>
              <TextField
                name="name"
                disabled={checkboxState}
                value={receiptObject.name || ""}
                onChange={(e) => handleInputText(e)}
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.box}>
              <UsoCfdiSelect
                option={receiptObject.usoCfdi}
                errorCFDI={errorCFDI}
                cfdiValue={handleCFDISelected}
              />
            </Box>
          </Grid>

          {!checkboxState && (
            <>
              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Calle
                  </Typography>
                  <TextField
                    name="street"
                    className={classes.textField4}
                    value={receiptObject.street || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 20 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    # exterior
                  </Typography>
                  <TextField
                    name="exteriorNumber"
                    className={classes.textField4}
                    value={receiptObject.exteriorNumber || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 5 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    # interior
                  </Typography>
                  <TextField
                    name="interiorNumber"
                    className={classes.textField4}
                    value={receiptObject.interiorNumber || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 5 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    CP
                  </Typography>
                  <InputMask
                    mask="99999"
                    maskChar=""
                    value={receiptObject.cp || ""}
                    onChange={(e) => handleInputText(e)}
                  >
                    {() => (
                      <TextField
                        name="cp"
                        className={classes.textField4}
                        value={receiptObject.cp}
                        variant="outlined"
                      />
                    )}
                  </InputMask>
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Colonia
                  </Typography>
                  <TextField
                    name="colonia"
                    className={classes.textField4}
                    value={receiptObject.colonia || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 25 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Municipio
                  </Typography>
                  <TextField
                    name="municipio"
                    className={classes.textField4}
                    value={receiptObject.municipio || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 25 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Estado
                  </Typography>
                  <TextField
                    name="estado"
                    className={classes.textField4}
                    value={receiptObject.estado || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 25 }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Email
                  </Typography>
                  <TextField
                    name="email"
                    autoComplete="off"
                    className={classes.textField4}
                    value={receiptObject.email || ""}
                    onChange={(e) => handleInputText(e)}
                    variant="outlined"
                    inputProps={{ maxLength: 30 }}
                  />
                </Box>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkboxState}
                  onChange={() => handleGlobalReceipt()}
                  name="checkedB"
                  color="primary"
                />
              }
              label="Rellenar campos para factura global"
            />
          </Grid>

          <ConfirmButtons
            disabled={acceptButtonDisabled}
            handleSubmitForm
            cancel={() => onClose()}
            accept={handleSubmitReceipt}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actionsAlert.detailAlert,
  addAlert: actionsAlert.addAlert,
};

export default connect(null, dispatch)(GenerateReceipt);
